import React, { createContext } from 'react';

export interface SchoolSetup {
  hasClasses: boolean;
  hasTeachers: boolean;
  hasStudents: boolean;
}

export interface SchoolStatus {
  id: number;
  school_name: string;
  subscription_tier: 'standard' | 'white_label';
  is_active: boolean;
  created_at: string;
  activeAcademicYearId?: number;
  setup: SchoolSetup;
}

export interface ParentAppContextType {
  school: SchoolStatus | null;
  refreshStatus: () => void;
}

export const ParentAppContext = createContext<ParentAppContextType>({
  school: null,
  refreshStatus: () => {},
});

export const useParentAppSchool = () => {
  const context = React.useContext(ParentAppContext);
  if (!context) {
    throw new Error('useParentAppSchool must be used within ParentAppLayout');
  }
  return context;
};
